import React, { forwardRef } from 'react';
import MUIChip, { ChipProps } from '@mui/material/Chip';
import styled from '@emotion/styled';
import gradients from '../Theme/gradients';

const Chip = forwardRef<HTMLDivElement, ChipProps>((properties, reference) => (
  <MUIChip ref={reference} {...properties} />
));

export const StyledChip = styled(Chip)`
  font-weight: 500;
  font-size: .75rem;

  &.MuiChip-colorPrimary {
    background-image: linear-gradient(to right, ${gradients.subtle});
  }
`;

export default Chip;
